import { InvokeCommand, type InvokeCommandInput, LambdaClient } from '@aws-sdk/client-lambda';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import Log from '@/Logger';
import { getIdToken } from '@/auth';
import { type PDFSender } from './SendDocument.hooks';

//kintone-formpdfsenderのLambda関数を呼び出す。
export const invoke_pdfSender = async (mergedJson: PDFSender) => {
    const logger = Log.getLogger();
    try {
        logger.api.info('Cognito', 'Start to InvokeCommand: kintone-formpdfsender');

        const _resp = await _InvokeCommand(mergedJson);

        if (_resp.status !== 'success') {
            throw new Error('Fail to Invoke lambda function: kintone-formpdfsender')
        }
        return {
            status: _resp.status,
            message: _resp.message
        };
    } catch (err) {
        logger.api.error('Cognito', 'Fail to request: kintone-formpdfsender', err);
        throw err;
    }
}


async function _InvokeCommand(mergedJson: any) {
    const logger = Log.getLogger();
    try {
        const client = new LambdaClient(await getConf());
        logger.api.info('Lambda', 'Start to request');
        const command = new InvokeCommand({
            FunctionName: import.meta.env.VITE_AWS_PDFSENDER_ARN,
            Payload: new TextEncoder().encode(`${JSON.stringify(mergedJson)}`)
        } as InvokeCommandInput);
        const response = await client.send(command);
        logger.api.info('Lambda', 'Succeed to request: InvokeCommand', getMetadata(response));

        return JSON.parse(new TextDecoder().decode(response.Payload));
    } catch (err) {
        logger.api.error('Lambda', 'Fail to request: InvokeCommand', err);
    }
}

const getConf = async () => {
    const logger = Log.getLogger();
    try {
        logger.api.info('Cognito', 'Start to request: getAccessToken');
        const token = await getIdToken();
        logger.api.info('Cognito', 'Succeed to request: getAccessToken');
        const conf = {
            region: import.meta.env.VITE_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: import.meta.env.VITE_AWS_REGION },
                identityPoolId: import.meta.env.VITE_AWS_IDENTITY_POOL_ID as string,
                logins: {
                    ['cognito-idp.ap-northeast-1.amazonaws.com/' + import.meta.env.VITE_AWS_USER_POOL_ID as string]: token.toString(),
                },
            })
        }
        return conf;
    } catch (err) {
        logger.api.error('Cognito', 'Fail to request: currentSession', err);
        throw err;
    }
}

function getMetadata(resp: any) {
    return resp?.['$metadata'];
}